export enum LocalStorageKeysEnum {
	ACCESS_TOKEN = 'access_token',
	REFRESH_TOKEN = 'refresh_token',
	CATEGORY_ITEMS_SHOWN_COLUMNS = 'category_items_shown_columns',
	LOGS = 'logs',
}
